import link from './files/link.svg'
import me from './files/me.jpg'

export default {
  link,
  me
}
